module.exports = __webpack_public_path__ + "static/property-prediction-report-dfe8e825f1ebffa8fe5eeab288092dbe.png";